import { Navigate, Outlet } from 'react-router';
import { getLocalStorageItem } from '../utils/Validation';

const PublicRoute = () => {
  const token = getLocalStorageItem('authToken');

  return token ? <Navigate to="/" /> : <Outlet />;
};

export default PublicRoute;